import { OnInit, OnDestroy, Input, ChangeDetectorRef, Component, AfterViewInit, ViewChild } from '@angular/core';
import * as jQuery from 'jquery';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS, FILE_MEDIA_TYPES } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { PATHS } from '../../../analytics/constants/analytics.constants';

// tslint:disable-next-line:interface-name
interface IMediaFile {
	type: string;
	url: string;
	width: number;
	height: number;
}

@Component({
	selector: 'app-preroll-creative',
	styleUrls: ['./preroll-creative.component.css'],
	templateUrl: './preroll-creative.component.html'
})
export class PrerollCreativeComponent implements OnInit, OnDestroy, AfterViewInit {
	@Input() defaultsort: string;
	@Input() downloadconfig: string;
	@Input() downloadcsvcolumns: any;
	@ViewChild('videoName') videoplayer: any;
	@Input() sectionclass: any;
	displayData: any;
	setDisplayProperties: any;
	getDisplayIndex: any;
	count: any;
	showLoad = true;
	carouselItemsLength: number;
	primaryColor: string;
	defaultColor: string;
	public videoCreativeData: any;
	public key: string;
	public downloadConfiguration: DownloadConfig;
	public downloadCSVColumns;
	public colorPalette: ColorPalette;
	public hasData = true;
	public reloadSubscription;
	public widgetDataSubscription;
	public isR4: boolean = false;
	public youtubeViewsPermission: boolean = false;
	public youtubeViewsPermissionCheck: object = { permission: { flags: ['hasYoutubeViews'] } };
	public isPreroll: boolean = false;
	public isR1: boolean = false;
	public isR101: boolean = false;
	public isR8: boolean = false;
	public isR104: boolean = false;
	public isR102: boolean = false;
	public isGam: boolean = false;
	public isGamVideoCreativeAvailable: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef
	) {
		this.setDisplayProperties = {
			audioURL: '',
			impressions: 0,
			clicks: 0,
			click_rate: 0,
			completion_rate: 0,
			percent_value_25: 0,
			percent_rate_25: 0,
			percent_value_50: 0,
			percent_rate_50: 0,
			percent_value_75: 0,
			percent_rate_75: 0,
			percent_value_100: 0,
			percent_rate_100: 0,
			name: '',
			thumbnail: '',
			mp4: ''
		};
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.hasData = true;
			this.showLoad = true;
			this.cdr.detectChanges();
			const mediaElement = jQuery('#preRollvideo')[0];
			if (mediaElement) {
				mediaElement.muted = true;
			}
			this.controlsOptions(this.primaryColor, this.defaultColor);
			if (this.videoCreativeData) {
				this.showLoad = false;
				this.hasData = true;
				this.setData(this.videoCreativeData);
			} else {
				this.requestData();
			}
		});
	}

	ngAfterViewInit() {
		this.cdr.detectChanges();
		this.controlsOptions(this.primaryColor, this.defaultColor);
	}

	ngOnInit() {
		this.hasData = true;
		this.showLoad = true;
		this.count = 1;
		this.isGam = this.analyticsDataModel.getCurrentPath() === PATHS.GAM;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.isR101 = this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r101' ? true : false;
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.isR102 = this.analyticsDataModel.config.partner.directoryName === 'default-r102' ? true : false;
		this.isR8 = this.analyticsDataModel.config.version === 'R8' ? true : false;
		if (this.isR8) {
			this.primaryColor = '#4A4A4A';
		} else {
			this.primaryColor = this.colorPalette.primaryColor;
		}
		this.defaultColor = 'white';
		this.youtubeViewsPermission = this.analyticsDataModel.checkComponentForPermission(this.youtubeViewsPermissionCheck);
		this.isPreroll = this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		if (this.defaultsort === 'true') {
			this.defaultsort = JSON.parse(this.defaultsort);
		} else {
			this.defaultsort = null;
		}
		if (this.videoCreativeData) {
			this.showLoad = false;
			this.hasData = true;
			this.setData(this.videoCreativeData);
		} else {
			this.requestData();
		}
		this.controlsOptions(this.primaryColor, this.defaultColor);
		this.isR4 = this.analyticsDataModel.config.version === 'R4' ? true : false;
		this.isR1 = this.analyticsDataModel.config.version === 'R1' ? true : false;
	}

	requestData() {
		if (this.isR8 && this.isGam) {
			this.analyticsService.processCustomServiceRequest(this.key).subscribe((res: any) => {
				this.showLoad = false;
				if (res.success && res.data.length > 0) {
					this.hasData = true;
					// if (this.isR8 && this.isGam && res.data.length > 0) {
					// 	jQuery('div#' + this.uniqueoverwriteid).removeClass('hideWidget');
					// } else if (this.isR8 && this.isGam) {
					// 	jQuery('div#' + this.uniqueoverwriteid).addClass('hideWidget');
					// }
					this.setData(res.data);
				} else {
					// if (this.isR8 && this.isGam) {
					// 	jQuery('div#' + this.uniqueoverwriteid).addClass('hideWidget');
					// }
					this.hasData = false;
					this.displayData = [];
					this.carouselItemsLength = 0;
				}
			});
		} else {
			this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
				this.showLoad = false;
				if (res.success && res.data.length > 0) {
					this.hasData = true;
					this.setData(res.data);
				} else {
					this.hasData = false;
					this.displayData = [];
					this.carouselItemsLength = 0;
				}
			});
		}
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	setData(response) {
		if (jQuery('#preRollvideo')[0]) {
			jQuery('#preRollvideo')[0].autoplay = true;
		}
		this.displayData = response;
		if (!this.defaultsort) {
			this.getDisplayIndex = this.displayData.length - 1;
		} else {
			this.getDisplayIndex = 0;
		}
		this.carouselItemsLength = this.displayData.length;
		this.setSlide();
		this.setDisplayIndexContent(this.getDisplayIndex);
	}

	setSlide() {
		this.nextArrow();
		this.prevArrow();
	}

	getMp4FromMediaFilesJson(mediaFilesJson: string) {
		let mp4Link: string = null;

		let decodedMediaFiles: Array<IMediaFile>;
		let isJsonDecodeSuccess = false;
		try {
			decodedMediaFiles = JSON.parse(mediaFilesJson);
			isJsonDecodeSuccess = true;
		} catch (e) {
			isJsonDecodeSuccess = false;
		}

		if (isJsonDecodeSuccess && decodedMediaFiles) {
			let fallBackMediaFile: IMediaFile;
			for (const mediaFile of decodedMediaFiles) {
				if (mediaFile.type === FILE_MEDIA_TYPES.MP4) {
					if (mediaFile.width === 640 && mediaFile.height === 360) {
						mp4Link = mediaFile.url;
						break;
					} else {
						if (fallBackMediaFile) {
							if (fallBackMediaFile.width > mediaFile.width && mediaFile.width >= 640) {
								fallBackMediaFile = mediaFile;
							}
						} else {
							fallBackMediaFile = mediaFile;
						}
					}
				}
			}

			if ((mp4Link === null || mp4Link === '') && fallBackMediaFile) {
				mp4Link = fallBackMediaFile.url;
			}
		}

		return mp4Link;
	}

	setDisplayIndexContent(getDisplayIndex) {
		if (this.displayData) {
			jQuery('#volumeBtn').hide();
			jQuery('#muteBtn').hide();
			jQuery('#playBtn').hide();
			jQuery('#pauseBtn').hide();
			if (this.displayData.length === 0) {
				this.setDisplayProperties = {
					audioURL: '',
					click_rate: 0,
					clicks: 0,
					completion_rate: 0,
					impressions: 0,
					mp4: '',
					name: '',
					percent_rate_100: 0,
					percent_rate_25: 0,
					percent_rate_50: 0,
					percent_rate_75: 0,
					percent_value_100: 0,
					percent_value_25: 0,
					percent_value_50: 0,
					percent_value_75: 0,
					thumbnail: ''
				};
			} else if (this.displayData[getDisplayIndex]) {
				let setImpressions = this.displayData[getDisplayIndex].impressions;
				let setClicks = this.displayData[getDisplayIndex].clicks;
				let setClick_rate = this.displayData[getDisplayIndex].click_rate;
				let set25PercentValue = this.displayData[getDisplayIndex]['25_percent_value'];
				let set25PercentRate = this.displayData[getDisplayIndex]['25_percent_rate'];
				let set50PercentValue = this.displayData[getDisplayIndex]['50_percent_value'];
				let set50PercentRate = this.displayData[getDisplayIndex]['50_percent_rate'];
				let set75PercentValue = this.displayData[getDisplayIndex]['75_percent_value'];
				let set75PercentRate = this.displayData[getDisplayIndex]['75_percent_rate'];
				let set100PercentValue = this.displayData[getDisplayIndex]['100_percent_value'];
				let set100PercentRate = this.displayData[getDisplayIndex]['100_percent_rate'];
				let completionRate = this.displayData[getDisplayIndex]['100_percent_rate'];
				let setMp4Link = this.displayData[getDisplayIndex].mp4;
				let setAudioURL = this.displayData[getDisplayIndex].audio_url
					? this.displayData[getDisplayIndex].audio_url
					: this.displayData[getDisplayIndex].audioURL;
				const setMediaFiles = this.displayData[getDisplayIndex].media_files;
				let isNonManagedVideo = this.displayData[getDisplayIndex].fetch_direct_video == '1' ? true : false;
				const setThumbnailLink = this.displayData[getDisplayIndex].thumbnail;
				if (setImpressions == null || setImpressions === '') {
					setImpressions = 0;
				}
				if (setClicks == null || setClicks === '') {
					setClicks = 0;
				}
				if (setClick_rate == null || setClick_rate === '') {
					setClick_rate = 0;
				}
				if (set25PercentValue == null || set25PercentValue === '') {
					set25PercentValue = 0;
				}
				if (set25PercentRate == null || set25PercentRate === '') {
					set25PercentRate = 0;
				}
				if (set50PercentValue == null || set50PercentValue === '') {
					set50PercentValue = 0;
				}
				if (set50PercentRate == null || set50PercentRate === '') {
					set50PercentRate = 0;
				}
				if (set75PercentValue == null || set75PercentValue === '') {
					set75PercentValue = 0;
				}
				if (set75PercentRate == null || set75PercentRate === '') {
					set75PercentRate = 0;
				}
				if (set100PercentValue == null || set100PercentValue === '') {
					set100PercentValue = 0;
				}
				if (set100PercentRate == null || set100PercentRate === '') {
					set100PercentRate = 0;
					completionRate = 0;
				}
				if (setMp4Link === null || setMp4Link === '') {
					setMp4Link = isNonManagedVideo ? setMediaFiles : this.getMp4FromMediaFilesJson(setMediaFiles);
				}
				if (setAudioURL == null || setAudioURL === '') {
					setAudioURL = '';
				}
				setClick_rate = parseFloat(setClick_rate).toFixed(2);
				set25PercentRate = parseFloat(set25PercentRate).toFixed(2);
				set50PercentRate = parseFloat(set50PercentRate).toFixed(2);
				set75PercentRate = parseFloat(set75PercentRate).toFixed(2);
				set100PercentRate = parseFloat(set100PercentRate).toFixed(2);
				completionRate = parseFloat(completionRate).toFixed(2);
				this.setDisplayProperties = {
					audioURL: setAudioURL,
					click_rate: setClick_rate,
					clicks: setClicks,
					completion_rate: completionRate,
					impressions: setImpressions,
					mp4: setMp4Link,
					name: this.displayData[getDisplayIndex].name,
					percent_rate_100: set100PercentRate,
					percent_rate_25: set25PercentRate,
					percent_rate_50: set50PercentRate,
					percent_rate_75: set75PercentRate,
					percent_value_100: set100PercentValue,
					percent_value_25: set25PercentValue,
					percent_value_50: set50PercentValue,
					percent_value_75: set75PercentValue,
					thumbnail: this.displayData[getDisplayIndex].thumbnail
				};
				this.isGamVideoCreativeAvailable = this.setDisplayProperties?.mp4 ? true : false;
				if (this.setDisplayProperties.mp4) {
					jQuery('#volumeBtn').hide();
					jQuery('#muteBtn').show();
					jQuery('#playBtn').hide();
					jQuery('#pauseBtn').show();
					const mediaElement = jQuery('#preRollvideo')[0];
					if (mediaElement) {
						mediaElement.autoplay = true;
						mediaElement.muted = true;
					}
					jQuery('#videoDisplayblock').show();
				} else if (this.setDisplayProperties.audioURL) {
					this.controlsOptions(this.primaryColor, this.defaultColor);
					const mediaElement = jQuery('#preRollvideo')[0];
					if (mediaElement) {
						mediaElement.autoplay = false;
						mediaElement.muted = false;
					}
					jQuery('#videoDisplayblock').show();
					if (this.isR4) {
						jQuery('#volumeBtn').show();
						jQuery('#muteBtn').hide();
						jQuery('#playBtn').show();
						jQuery('#pauseBtn').hide();
					}
				} else {
					jQuery('#volumeBtn').hide();
					jQuery('#muteBtn').hide();
					jQuery('#playBtn').hide();
					jQuery('#pauseBtn').hide();
					jQuery('#videoDisplayblock').hide();
				}
			}
			if (this.youtubeViewsPermission && this.isPreroll) {
				this.setDisplayProperties['youtube_verified_imprs'] =
					this.displayData[getDisplayIndex].youtube_verified_imprs == null ||
					this.displayData[getDisplayIndex].youtube_verified_imprs == ''
						? 0
						: this.displayData[getDisplayIndex].youtube_verified_imprs;
				this.setDisplayProperties['youtube_verified_imprs_rate'] = parseFloat(
					this.displayData[getDisplayIndex].youtube_verified_imprs_rate == null ||
						this.displayData[getDisplayIndex].youtube_verified_imprs_rate == ''
						? 0
						: this.displayData[getDisplayIndex].youtube_verified_imprs_rate
				).toFixed(2);
			}
		}
	}

	nextArrow() {
		if (this.displayData.length > 1) {
			if (0 === this.getDisplayIndex) {
				this.getDisplayIndex = this.displayData.length - 1;
				this.setDisplayIndexContent(this.getDisplayIndex);
			} else {
				this.getDisplayIndex = this.getDisplayIndex - 1;
				this.setDisplayIndexContent(this.getDisplayIndex);
			}
		}
		if (this.count === 1) {
			this.count = this.displayData.length;
		} else {
			this.count = this.count - 1;
		}
		if (jQuery('#preRollvideo')[0]) {
			jQuery('#preRollvideo')[0].autoplay = true;
		}
		jQuery('#svg_25Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
		jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
		jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
		jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
	}

	prevArrow() {
		if (this.displayData.length > 1) {
			if (this.displayData.length - 1 === this.getDisplayIndex) {
				this.getDisplayIndex = 0;
				this.setDisplayIndexContent(this.getDisplayIndex);
			} else {
				this.getDisplayIndex = this.getDisplayIndex + 1;
				this.setDisplayIndexContent(this.getDisplayIndex);
			}
		}
		if (this.displayData.length === this.count) {
			this.count = 1;
		} else {
			this.count = this.count + 1;
		}
		if (jQuery('#preRollvideo')[0]) {
			jQuery('#preRollvideo')[0].autoplay = true;
		}
		jQuery('#svg_25Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
		jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
		jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
		jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
	}

	circleVideoClickEvent(typeOfPercent) {
		if (this.setDisplayProperties.mp4 != null) {
			const gettheVideoTotalDuration = this.videoplayer.nativeElement.duration;
			const gettheEqualDuration = parseFloat(gettheVideoTotalDuration) / 4;
			const splitURL = this.setDisplayProperties.mp4.split('#');
			this.setDisplayProperties.mp4 = splitURL[0];
			const urlName = this.setDisplayProperties.mp4;
			const setStartEndTime = '';
			let getStartTime;
			let getEndTime;
			let calcDuration;
			if (typeOfPercent === 0) {
				jQuery('#svg_0Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_25Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#preRollvideo')[0].currentTime = 0;
				jQuery('#preRollvideo')[0].play();
				getStartTime = 0;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = gettheEqualDuration - getStartTime;
				calcDuration = calcDuration * 1000;
				jQuery('#svg_0Percent').css({ backgroundColor: this.primaryColor, opacity: 0.07 });
				jQuery('#svg_0Percent').animate(
					{ opacity: 1.0 },
					{
						duration: calcDuration,
						easing: 'linear'
					}
				);
				jQuery('#svg_0Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_25Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
			} else if (typeOfPercent === 25) {
				jQuery('#preRollvideo')[0].currentTime = gettheEqualDuration;
				jQuery('#preRollvideo')[0].play();
				getStartTime = 0;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = gettheEqualDuration - getStartTime;
				calcDuration = calcDuration * 1000;
				jQuery('#svg_25Percent').css({ backgroundColor: this.primaryColor, opacity: 0.07 });
				jQuery('#svg_25Percent').animate(
					{ opacity: 1.0 },
					{
						duration: calcDuration,
						easing: 'linear'
					}
				);
				jQuery('#svg_0Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
				jQuery('#svg_25Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
			} else if (typeOfPercent === 50) {
				jQuery('#preRollvideo')[0].currentTime = gettheEqualDuration + gettheEqualDuration;
				jQuery('#preRollvideo')[0].play();
				getStartTime = gettheEqualDuration;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = getEndTime - getStartTime;
				calcDuration = calcDuration * 1000;
				jQuery('#svg_50Percent').css({ backgroundColor: this.primaryColor, opacity: 0.07 });
				jQuery('#svg_50Percent').animate(
					{ opacity: 1.0 },
					{
						duration: calcDuration,
						easing: 'linear'
					}
				);
				jQuery('#svg_0Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
				jQuery('#svg_25Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
			} else if (typeOfPercent === 75) {
				jQuery('#preRollvideo')[0].currentTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				jQuery('#preRollvideo')[0].play();
				getStartTime = gettheEqualDuration + gettheEqualDuration;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = getEndTime - getStartTime;
				calcDuration = calcDuration * 1000;
				jQuery('#svg_75Percent').css({ backgroundColor: this.primaryColor, opacity: 0.07 });
				jQuery('#svg_75Percent').animate(
					{ opacity: 1.0 },
					{
						duration: calcDuration,
						easing: 'linear'
					}
				);
				jQuery('#svg_0Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
				jQuery('#svg_25Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
			} else if (typeOfPercent === 100) {
				const getCurrentTime = jQuery('#preRollvideo')[0].currentTime;
				const totDuration = jQuery('#preRollvideo')[0].duration;
				if (getCurrentTime < totDuration) {
					jQuery('#svg_0Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
					jQuery('#svg_25Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
					jQuery('#svg_50Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
					jQuery('#svg_75Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
					jQuery('#svg_100Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
					jQuery('#preRollvideo')[0].currentTime = gettheVideoTotalDuration - 1;
					jQuery('#preRollvideo')[0].play();
					getStartTime = gettheEqualDuration + gettheEqualDuration;
					getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
					calcDuration = getEndTime - getStartTime;
					calcDuration = calcDuration * 1000;
					jQuery('#svg_75Percent').css({ backgroundColor: this.primaryColor, opacity: 0.07 });
					jQuery('#svg_75Percent').animate(
						{ opacity: 1.0 },
						{
							duration: calcDuration,
							easing: 'linear'
						}
					);
					jQuery('#percent0').css('color', 'black');
					jQuery('#percent25').css('color', 'black');
					jQuery('#percent50').css('color', 'black');
					jQuery('#percent75').css('color', 'black');
					jQuery('#percent100').css('color', 'black');
				}
				if (getCurrentTime >= totDuration) {
					jQuery('#svg_0Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
					jQuery('#svg_25Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
					jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
					jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
					jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
					jQuery('#preRollvideo')[0].currentTime = 0;
					jQuery('#preRollvideo')[0].play();
					getStartTime = gettheEqualDuration + gettheEqualDuration;
					getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
					calcDuration = getEndTime - getStartTime;
					calcDuration = calcDuration * 1000;
					jQuery('#svg_75Percent').css({ backgroundColor: this.primaryColor, opacity: 0.07 });
					jQuery('#svg_75Percent').animate(
						{ opacity: 1.0 },
						{
							duration: calcDuration,
							easing: 'linear'
						}
					);
				}
			}
		}
	}

	controlsOptions(primaryColor?, defaultColor?) {
		const media = document.getElementById('preRollvideo');
		let gettheVideoTotalDuration;
		let checkfor0Percentage;
		let checkfor25Percentage;
		let checkfor50Percentage;
		let checkfor75Percentage;
		let checkfor100Percentage;
		const isPlaying = function (e) {
			gettheVideoTotalDuration = jQuery('#preRollvideo')[0].duration;
			checkfor0Percentage = 0 / 4;
			checkfor25Percentage = gettheVideoTotalDuration / 4;
			checkfor50Percentage = parseFloat(checkfor25Percentage) * 2;
			checkfor75Percentage = parseFloat(checkfor25Percentage) * 3;
			checkfor100Percentage = parseFloat(checkfor25Percentage) * 4;
			jQuery('#pauseBtn').show();
			jQuery('#playBtn').hide();
		};
		const onPause = function (e) {
			jQuery('#pauseBtn').hide();
			jQuery('#playBtn').show();
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime === gettheVideoTotalDuration) {
				jQuery('#svg_0Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_25Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: primaryColor, color: primaryColor });

				jQuery('#percent0').css('color', 'black');
				jQuery('#percent25').css('color', 'black');
				jQuery('#percent50').css('color', 'black');
				jQuery('#percent75').css('color', 'black');
				jQuery('#percent100').css('color', 'black');
			}
		};
		const onTimeUpdate = function (e) {
			jQuery('#svg_0Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			jQuery('#svg_25Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			jQuery('#svg_0Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 1.0 });
			jQuery('#percent0').css('color', 'black');
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor25Percentage) {
				jQuery('#svg_25Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 0.1 });
				jQuery('#svg_25Percent').animate(
					{ opacity: 1.0 },
					{
						duration: checkfor25Percentage * 1000,
						easing: 'linear'
					}
				);
				jQuery('#percent25').css('color', 'black');
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor25Percentage) {
				jQuery('#percent25').css('color', '#607d8b');
				jQuery('#svg_50Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor50Percentage) {
				jQuery('#svg_50Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 0.1 });
				jQuery('#svg_50Percent').animate(
					{ opacity: 1.0 },
					{
						duration: checkfor25Percentage * 1000,
						easing: 'linear'
					}
				);
				jQuery('#percent50').css('color', 'black');
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor50Percentage) {
				jQuery('#percent50').css('color', '#607d8b');
				jQuery('#svg_50Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor75Percentage) {
				jQuery('#svg_75Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 1.0 });
				jQuery('#percent75').css('color', 'black');
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor75Percentage) {
				jQuery('#percent75').css('color', '#607d8b');
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor100Percentage) {
				jQuery('#svg_100Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 1.0 });
				jQuery('#percent100').css('color', 'black');
				jQuery('#playBtn').show();
				jQuery('#pauseBtn').hide();
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor100Percentage) {
				jQuery('#percent100').css('color', '#607d8b');
			}
		};
		if (media) {
			media.addEventListener('playing', isPlaying, false);
			media.addEventListener('pause', onPause, false);
			media.addEventListener('timeupdate', onTimeUpdate, false);
		}
	}

	playclickEvent() {
		jQuery('#playBtn').hide();
		jQuery('#pauseBtn').show();
		jQuery('#preRollvideo')[0].play();
		this.controlsOptions(this.primaryColor, this.defaultColor);
	}

	pauseclickEvent() {
		jQuery('#playBtn').show();
		jQuery('#pauseBtn').hide();
		jQuery('#preRollvideo')[0].pause();
		this.controlsOptions(this.primaryColor, this.defaultColor);
	}

	volumeclick() {
		jQuery('#volumeBtn').hide();
		jQuery('#muteBtn').show();
		jQuery('#preRollvideo')[0].muted = true;
	}

	muteclick() {
		jQuery('#volumeBtn').show();
		jQuery('#muteBtn').hide();
		jQuery('#preRollvideo')[0].muted = false;
	}

	downloadDataInCSV(event: any) {
		event.preventDefault();
		const qkey = this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key;
		this.analyticsService.downloadCSV(qkey, this.downloadConfiguration.fileName, this.downloadCSVColumns);
	}
}
